module.exports = __webpack_public_path__ + "static/media/AlmondStages1-9.c406b9dd.PNG";